<template>
<div class="footer-wrapper">
  <div class="footer">
    <div class="title">{{$t('contact.title')}}</div>
    <div class="desc-info">
      <div class="desc">{{$t('contact.e-mail')}}：sales@hewvo.com</div>
      <div class="desc">Website：www.hewvo.com</div>
      <div class="descAdd">Address：7500A BEACH ROAD #05-319 THE PLAZA SINGAPORE(199591)</div>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: "footer"
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  .footer {
    width: 1200px;
    margin: 0 auto;
  }
  //background-color: #FFEFE9;
  border-top: 1px solid #ececec;
  color: #ffffff;
  background: #FF6B35;
  padding: 20px 50px;
  .desc-info {
    display: flex;
  }
  .title {
    font-weight: 700;
  }
  .desc {
    flex: 1;
    padding-top: 10px;
    color: #ffffff;
    font-size: 14px;
  }
  .descAdd{
    flex: 2;
    padding-top: 10px;
    color: #ffffff;
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .footer-wrapper {
    width: 100%;
    box-sizing: border-box;
    .footer {
      width: 100%;
      box-sizing: border-box;
      margin: 0 auto;
    }
    .desc-info {
      display: block;
    }
  }
}

</style>
